import React, { memo } from "react";
import classnames from "classnames";
import { Element } from "../base";
import RouterLink from "../links";

interface IProps {
    className?: string;
    classNameLink?: string;
    children: React.ReactNode;
    to: string;
    as: string;
    arrowless?: string;
}

function NavbarLink(props: IProps) {
    const { children, className, classNameLink, to, arrowless, ...rest } =
        props;

    return (
        <Element
            {...rest}
            className={classnames("navbar-link", "inline-block", className, {
                ["is-arrowless"]: arrowless,
            })}
        >
            <RouterLink className={classNameLink} to={to}>
                {children}
            </RouterLink>
        </Element>
    );
}

export default memo(NavbarLink);
